import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface ContactMessageParams {
    userId: string;
    fullName: string;
    companyName?: string;
    email: string;
    phone?: string;
    category?: string;
    message: string;
}

export const contactApi = createApi({
    reducerPath: 'contactApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_URL,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as any).auth.token || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        submitMessage: builder.mutation<any, ContactMessageParams>({
            query: (data) => ({
                url: '/message-request',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const { useSubmitMessageMutation } = contactApi;
